import { TimePicker } from '@mui/x-date-pickers';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../store';
import dayjs from 'dayjs';

export default function CusTimePicker({
  value,
  time,
  onChange,
  label,
  errorText = '',
  format = 'HH:mm',
  disabled,
  clearable
}) {
  const { t } = useTranslation();
  const defaultInputSize = useAppSelector((state) => state.customizer.inputSize);

  return (
    <TimePicker
      label={t(label)}
      format={format}
      value={value ? dayjs(value, format) : null}
      onChange={(newValue) => {
        // onChange(newValue ? getOnlyData(newValue, time, formatChange) : null);
        const timeString = newValue ? dayjs(newValue).format(format) : null;
        onChange(timeString);
      }}
      closeOnSelect={true}
      disabled={disabled}
      slotProps={{
        textField: {
          size: defaultInputSize,
          label: t(label),
          fullWidth: true,
          error: !!errorText,
          helperText: errorText,
          sx: { '& input': { paddingRight: '0' } },
          clearable: clearable,
          InputLabelProps: { shrink: true },
          placeholder: ''
        }
      }}
    />
  );
}
